

  

  // Code for hiding elements according to region

  const h2Element = document.querySelector('.comparison-content h2');
    if (h2Element) {
      if (h2Element.textContent.trim() !== '') {
          document.querySelector('.comparsion-table').style.display = "block"
      } else {
          document.querySelector('.comparsion-table').classList.add("hideSection");
      }
    }

  console.log("regions " + pageRegion);


//if(pageRegion !== "CA") {
  // console.log('HELLO')

  //if(document.querySelector('.pails-review')){
  //  document.querySelector('.pails-review').classList.add('hideSection')
  //}

  //if(document.querySelector('.pails-review-info')){
  //    document.querySelector('.pails-review-info').classList.add('hideSection')
  //}
//}

// var url = window.location.href;
// var section = document.getElementById("littergenie-cares");
// var reviews = document.querySelector('.product-tab-item.review');
// var headerDescription = document.querySelector('.header-description');
// var videoDescription = document.querySelector('.video-description');
// var question = document.getElementById('question-15d9d2f4-1bdd-49c8-9a99-58246020f05c-3');
// var comparison_table = document.querySelector('.comparison-content');
// var whereToBuy = document.querySelector('.where-to-buy-container');
// var partnersLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(4)');
// var listItems = partnersLink.querySelectorAll('li');
// var frenchHeading = document.getElementById('shopify-section-template--17264834052377__5a2c91a3-78e3-47dd-80d9-d34147becef2');
// var reviewsSectionHomepage = document.querySelector('.litter-genie-sections-customer-review-block');
// var accessoriesLink = document.querySelector('#shopify-section-footer > footer > div > div > div > div:nth-child(3) > div > div > ul > li:nth-child(3)');



// if(pageRegion == "FR") {
//    $("#MenuMobileListSection-menu li:eq(2)").hide();
// }

// //Add class to style the german blog page
// if(pageLang == "de") {
//   $('.main-blog').addClass('german-blog');
// }

// if(pageRegion == "DE" || pageRegion == "GB" || pageRegion == "FR" ) {
//   if(url.includes("contact")){
//     $('.footer').addClass('support-faq-margin');
//   }
//   if(reviewsSectionHomepage) {
//     reviewsSectionHomepage.style.display = 'none';
//   }
// }

// //Add class to footer in support page
 
//   // Check if the current page URL contains "support-faq"
//   if (url.includes("support-faq")) {
//     // Add a class to the footer element
//     $(".footer").addClass("support-faq-footer");
//   }

 

// // Hide Partners Link from footer
// if(pageRegion == "DE" || pageRegion === "GB" || pageRegion == "FR") {
// if (listItems.length >= 4) {
//   listItems[1].style.display = 'block';
// }
//    $(".faqs-row .faqs-item:eq(2)").hide();
// }

// if(pageRegion == "DE" || pageRegion === "GB" || pageRegion === "FR" || pageRegion === "CA") {
//    accessoriesLink.style.display = "none";
//   $('.list-menu li:eq(2)').hide();

//   document.addEventListener("DOMContentLoaded", function() {
//   var style = document.createElement("style");
//   style.textContent = "#MenuMobileListSection-menu > li:nth-child(3) { display: none; }";
//   document.head.appendChild(style);
// });
// }



// // Create a URL object
// var parsedUrl = new URL(url);

// // Get the region from the URL
//  var region = parsedUrl.pathname.split('/')[1];

// // ADD CLASSES TO PRODUCT CARD ACCORDING TO REGION
//  if(pageRegion == "US") {
//  $("div.card-product").addClass("us-product");
//    // console.log($("div.card-product"));
//    $("div.product-card-copy").addClass('us-product-copy');
//   }


// if (pageRegion === "GB" || pageRegion === "CA" || pageRegion === "FR" || pageRegion == "DE" ) {
//   if(section) {
// section.style.display = "none"
//   }
// } else {
//   if(section) {
//     section.style.display = "block"
//   }  
// }


// if (pageRegion === "GB" || pageRegion === "FR" || pageRegion == "DE" ) {
//   if(reviews) {
//     reviews.style.display = "none"
//   }

//     if(question) {
//     question.style.display = "none";
//   }

//   if(comparison_table) {
//     comparison_table.style.width = "35%"
//   }
// } 

 
// if(pageRegion == "CA" && pageLang == "fr") {
//    if(headerDescription) {
//   headerDescription.style.display = "block";
//   }
// }

// if(pageLang == "fr") {
//   frenchHeading.classList.add('french-heading-style');
// }


  
// Littergenie nav link
  // let littergenieLink = document.querySelector('[href*="littergenie.com"]');
  //     littergenieLink.setAttribute('target', '_blank');
  //     littergenieLink.setAttribute('rel', 'noopener');

  // if(pageRegion === "CA" && pageLang === "en"){

  //   if(littergenieLink){
  //     littergenieLink.href = "https://www.littergenie.com/en-ca"; 
  //   }

  // }

  // if(pageRegion === "CA" && pageLang === "fr"){

  //   if(littergenieLink){
  //     littergenieLink.href = "https://www.littergenie.com/fr-ca"; 
      
  //   }
  // }



  // console.log("region " + pageRegion);

